import React, {PureComponent} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import './styles.scss';
import {insertAfter} from '../../util';

class Modal extends PureComponent {
  constructor(props) {
    super(props);
    this.el = document.createElement('div');
  }

  componentDidMount() {
    const root = document.getElementById('root');
    insertAfter(this.el, root);
  }

  componentWillUnmount() {
    document.body.removeChild(this.el);
  }

  render() {
    const {children, onToggle} = this.props;
    return ReactDOM.createPortal(
      <div className="Modal">
        <div className="modal is-active">
          <div
            className="modal-background"
            onClick={onToggle}
          />
          <div
            className="modal-content"
          >
            {children}
          </div>
          <button
            type="button"
            className="modal-close is-large"
            aria-label="close"
            onClick={onToggle}
          />
        </div>
      </div>,
      this.el,
    );
  }
}

Modal.propTypes = {
  children: PropTypes.element.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default Modal;
